@let isAbsenceDragging = draggingItemId === absence.id;
@let hasAbsenceUpdatePermissions =
  can(RoleAction.Update, RolePermissionSubject.Absence);
@let isLowOpacity =
  isAbsenceDragging || !stackHighlightIds.includes(absence.id);
@let heightClass = isMoreThanOneAssignment ? 'h-50' : 'h-100';

<div class="w-100 h-100">
  <div
    nz-tooltip
    [nzTooltipTitle]="absenceTooltip"
    [nzTooltipColor]="'#fff'"
    [nzTooltipMouseEnterDelay]="0.3"
    nzTooltipPlacement="top"
    [nzTooltipOverlayStyle]="{ 'max-width': '450px', 'min-width': '250px' }"
    [ngClass]="heightClass"
    [draggable]="isAbsenceDraggable"
    (dragstart)="startDrag(absence, !!hasAbsenceUpdatePermissions)"
    (dragend)="absenceDragEnd.emit()"
    (click)="absenceSelected.emit({ left: null, right: null, id: absence.id })"
  >
    <ng-container
      *ngTemplateOutlet="
        deferredAbsenceCellViewCardHelperService.getPreviewTemplate();
        context: {
          absence: absence,
          isMinimalMode: isMinimalMode,
          isSelected: isSelected,
          cardTitle: (absence | getAbsenceTimelineCardTitle | async) ?? '',
          testId:
            'wilson-timeline-cell-view-absence:absence-card:' + absence.remark,
          isLowOpacity: isLowOpacity,
          heightClass: 'h-100',
        }
      "
    ></ng-container>
  </div>
  @if (isMoreThanOneAssignment) {
    <div
      nz-dropdown
      nzTrigger="click"
      [nzDropdownMenu]="contextMenuTemplate"
      [nzOverlayStyle]="{ 'max-width': '150px' }"
      [ngClass]="heightClass"
    >
      <ng-container
        *ngTemplateOutlet="
          deferredAbsenceCellViewCardHelperService.getMultipleAssignmentsTemplate();
          context: {
            isLowOpacity: isLowOpacity,
            heightClass: 'h-100',
          }
        "
      ></ng-container>
    </div>
  }
</div>

<ng-template #absenceTooltip>
  <wilson-timeline-absence-tooltip [absence]="absence">
  </wilson-timeline-absence-tooltip>
</ng-template>
